import initializeMobileMenu from './menu';
import initializeCollapse from './blocks/collapse';
import initializeFiles from './blocks/files';
import initializeIconBoxes from './blocks/icon-boxes';
import initializeNumbersBlock from './blocks/numbers';
import initializeFancyBox from './fancybox';
import initializeGallerySection from './blocks/gallery-section';
import initializeGalleryGrid from "./blocks/gallery-grid";
import initializeForm from './utils/form';
import initializeBrands from './blocks/brands';
import initializeGallerySlider from './blocks/gallery-slider';
import initializeGalleryText from './blocks/gallery-text';
import initializeIconBoxesAnimation from './blocks/icon-boxes-animation';
import initializeSearch from './blocks/search';
import initializeTabs from './blocks/tabs';
import './utils/scrollup';
// import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 1000
            });
        });
        initializeForm();
        initializeFancyBox();
        initializeMobileMenu();
        initializeCollapse();
        initializeFiles();
        initializeIconBoxes();
        initializeNumbersBlock();
        initializeGallerySection();
        initializeGalleryGrid();
        initializeBrands();
        initializeGallerySlider();
        initializeGalleryText();
        initializeIconBoxesAnimation();
        initializeSearch();
        initializeTabs();

        // const Woo = new WooCommerce();
    }
}

function initializeApp() {
    const app = new App();

}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}


window.onscroll = function() {stickyMenu()};

var header = document.getElementById("header");
var sticky = header.offsetTop;

function stickyMenu() {
    if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}
